const formatPrice = (price) => {
  return price.toLocaleString("en-US");
};

export default formatPrice;
